<template>
<div id="specifications">
   <div class="right-item">
      <el-button  type="primary" @click=tjggnewoks() plain>添加规格类型</el-button>
      <el-button  type="warning" @click=newoktypes() plain>编辑规格类型</el-button>
   </div>
   <el-tabs v-model="specificationsPageDto.specificationCateId" @tab-click="handleClick">
        <el-tab-pane
        v-for="item in tabList"
        :key="item.specificationCateId"
        :label="item.cateName"
        :name="item.specificationCateId"
      >
      </el-tab-pane>
      <div class="tos">
          <el-form :inline="true" :model="specificationsPageDto" label-width="100px">
             <el-form-item label="关键字：">
                <el-input v-model="specificationsPageDto.keyWords"></el-input>
             </el-form-item>
             <el-form-item>
                <el-button type="primary" plain @click="sjhsearchFor()">查询</el-button>
             </el-form-item>
          </el-form>
          <el-button class="left_item"  type="primary" @click=newoks()>添加规格</el-button>
       </div>
       <div class="tableform">
         <el-table
             :data="tableData"
             border
             stripe
             :cell-style="{'text-align':'center'}"
             :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
             style="width: 100%">
            
             <el-table-column
                prop="specName"
                label="规格名称"
                >
                <template slot-scope="{row:{ specName }}">
                {{ specName|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="specificationValues"
                label="规格明细"
                >
                <template slot-scope="scope">
                  <span v-for="(item, index) in scope.row.specificationValues" :key="index">
                           <span>{{ item.specificationValue }}，</span>
                        </span>
                </template>
             </el-table-column>
             <el-table-column fixed="right" label="操作" width="280">
                <template slot-scope="scope">
                      <i title="编辑" class="el-icon-alixiugai" style="color: #1296db;cursor: pointer;"  @click=bianjiClick(scope.row) ></i>
                      <i title="删除" class="el-icon-alishanchu" style="color: #d81e06;cursor: pointer;"  @click=dels(scope.row) ></i>
                </template>
             </el-table-column>
          </el-table>
          <div class="btnbox">
             <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="specificationsPageDto.pageNum"
                :page-sizes="[10, 15, 20]"
                :page-size="specificationsPageDto.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="this.totals">
             </el-pagination>
          </div>
       </div>
     </el-tabs>
       <!-- 注册用户弹框 -->
       <el-dialog title="添加规格" :visible.sync="increase" width="28%"  @close='closeDialog'>
            <div class="zdjsdd" >
               <el-form  label-width="80px">
                  <el-form-item label="规格名称">
                     <div class="form-input-wrapper">
                        <el-input v-model="specificationspltjgg.cateName" placeholder="请输入规格名称" class="input-field"></el-input>
                     </div>
                  </el-form-item>
               </el-form>
               <div v-for="(childItem, childIndex) in specificationspltjgg.specificationsAddDtos" :key="childIndex">
                  <el-form  label-width="80px">
                     <el-form-item :label="childIndex === 0 ? '规格明细' : ''">
                        <div class="form-input-wrapper">
                           <el-input v-model="childItem.specificationValue" placeholder="请输入规格明细" class="input-field"></el-input>
                           <el-button v-if="childIndex === 0" type="warning" @click="addChildItem" plain class="submit-button">添加明细</el-button>
                           <i v-else class="el-icon-alishanchu" style="color: #d81e06;width: 103px;cursor: pointer;"  @click=cbddelete(childIndex) ></i>
                        </div>
                     </el-form-item>
                     <el-form-item >
                     </el-form-item>
                  </el-form>
               </div>
            </div>
            <div slot="footer">
                <el-button @click="increase = false">取 消</el-button>
                <el-button type="primary"  @click="submitForm()">确 定</el-button>
            </div>
       </el-dialog>
       <!-- 修改弹框 -->
       <el-dialog title="修改" :visible.sync="dialogFormVisible" width="32%" class="zcyhtk"  @close='closeDialog'>
            <div class="zdjsdd" >
               <el-form  label-width="80px">
                  <el-form-item label="规格名称">
                     <div class="form-input-wrapper">
                        <el-input v-model="specificationsUpdateBatchDto.specName" placeholder="请输入规格名称" class="input-field"></el-input>
                     </div>
                  </el-form-item>
               </el-form>
               <div v-for="(childItem, childIndex) in specificationsUpdateBatchDto.specificationValues" :key="childIndex">
                  <el-form  label-width="80px">
                     <el-form-item :label="childIndex === 0 ? '规格明细' : ''">
                        <div class="form-input-wrapper">
                           <el-input v-model="childItem.specificationValue" placeholder="请输入规格明细" class="input-field"></el-input>
                           <el-button v-if="childIndex === 0" type="warning" @click="xgChildItem" plain class="submit-button">添加明细</el-button>
                           <i v-else class="el-icon-alishanchu" style="color: #d81e06;width: 103px;cursor: pointer;"  @click=ggmxscdelete(childIndex,childItem) ></i>
                        </div>
                     </el-form-item>
                     <el-form-item >
                     </el-form-item>
                  </el-form>
               </div>
            </div>
            <div slot="footer">
                <el-button @click="xgtkdfdqx">取 消</el-button>
                <el-button type="primary"  @click="xiugoks()">确 定</el-button>
            </div>
       </el-dialog>
        <!-- 添加类型 -->
        <el-dialog title="添加规格类型" :visible.sync="tjlxincrease" width="22%" class="zcyhtk" @close='closeDialog'>
        <el-form ref="serviceTypeDto" :model="serviceTypeDto" :rules="rules" label-width="80px" label-position="right" size="small">
            <el-form-item label="规格名称:" prop="cateName">
                <el-input v-model="serviceTypeDto.cateName" placeholder="请输入规格名称"></el-input>
            </el-form-item>
            <el-form-item label="规格描述:">
                <el-input v-model="serviceTypeDto.cateDesc" placeholder="请输入规格描述"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="tjlxincrease = false">取 消</el-button>
            <el-button type="primary"  @click="ggtjsubmitForm('serviceTypeDto',serviceTypeDto)">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 编辑规格类型 -->
      <el-dialog title="编辑规格类型" :visible.sync="increasetypes" width="32%"   @close='closeDialog'>
        <div class="tableform">
          <el-table
            :data="gglxdata"
            border
            stripe
            :cell-style="{'text-align':'center', 'cursor': 'pointer'}"
            :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
            style="width: 100%"
            >
            <el-table-column
              prop="cateName"
              label="规格名称"
              >
              <template slot-scope="{ row: { cateName } }">
                {{ cateName|| "—" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="cateDesc"
              label="规格描述">
              <template slot-scope="{ row: { cateDesc } }">
                {{ cateDesc|| "—" }}
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="180">
                <template slot-scope="scope">
                  <el-button type="text" size="small" style="color: #1b93ed;" @click="gglxjiClick(scope.row)">编辑</el-button>
                  <el-button type="text" size="small" style="color: #FF2626;" @click="fwlxdels(scope.row)">删除</el-button>
                </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
</div>
</template>
<script>
   export default {
   name:'specifications',
   data(){
    return{
      specificationsPageDto:{
         pageNum:1,
         pageSize:10,
         keyWords:null,
         specificationCateId:null,
      },
      tabList: [],
      tableData: [],
      totals:10,
      increase:false,
      dialogFormVisible:false,
      increasetypes:false,
      zcrules: {
         userName: [
         { required: true, message: '请输入账号', trigger: 'blur' },
         // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
         ],
      },
      specificationspltjgg: {
         cateDesc: null,
         cateName: null,
         specificationCateId: null,
         specificationsAddDtos: [
            {
            specificationValue:null
         }]
      },
      tjlxincrease:false,
      serviceTypeDto:{
         cateDesc:null,
         cateName:null,
         specificationCateId:null,
      },
      specificationsUpdateBatchDto:{},
      rules: {
         cateName: [
         { required: true, message: '请输入规格名称', trigger: 'change' }
         ]
      },
      gglxdata:[],
      specificationsId:null
    }
   },
   created(){
      this.dataService()
   },
   mounted(){
   },
   methods:{
    addChildItem() {
      let datalist={
            specificationValue:null
      }
      this.specificationspltjgg.specificationsAddDtos.push(datalist);
    },
    xgChildItem() {
      let datalist={
            specificationValue:null
      }
      this.specificationsUpdateBatchDto.specificationValues.push(datalist);
    },
      getlist(specificationsPageDto) {
          this.$api.gglbyationsPage(specificationsPageDto)
          .then((res) => {
                this.tableData = res.data.data.records
                this.totals = res.data.data.total
          })
       },
      dataService() {
         this.$api.specificationCate().then((res) => {
               if(res.data.code==200){
                  this.tabList = res.data.data
                  this.gglxdata = res.data.data
                  this.$nextTick(() => {
                     if (this.tabList.length>0) {
                        this.specificationsPageDto.specificationCateId = this.tabList[0].specificationCateId; 
                        this.specificationspltjgg.specificationCateId = this.tabList[0].specificationCateId; 
                        this.getlist(this.specificationsPageDto)
                     }
                  });
               }else{
                  this.$message.error(res.data.message)
               }
         })
      },
      handleClick(tab, event) {
         this.specificationspltjgg.specificationCateId = tab.name
         this.getlist(this.specificationsPageDto)
      },
      sjhsearchFor(){
          this.getlist(this.specificationsPageDto)
       },
       newoks() {
         this.increase = true
      },
      tjggnewoks(){
         this.tjlxincrease = true
      },
      newoktypes(){
         this.increasetypes = true
         this.dataService()
      },
      submitForm(){
         this.$api.pltjggadd(this.specificationspltjgg).then((res) => {
            if (res.data.code == 200) {
               this.$message.success(res.data.message)
               this.increase = false
               this.getlist(this.specificationsPageDto)
            } else {
            this.$message.error(res.data.message)
            }
         })
      },
      ggtjsubmitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$api.operatorSpe(this.serviceTypeDto).then((res) => {
                if (res.data.code == 200) {
                    this.tjlxincrease = false
                    this.serviceTypeDto={
                        cateDesc:null,
                        cateName:null,
                        specificationCateId:null,
                    }
                    this.dataService()
                    this.$message.success(res.data.message)
                } else {
                  this.$message.error(res.data.message)
                }
              })
            } 
          });
      },
      cbddelete(index){
        this.specificationspltjgg.specificationsAddDtos.splice(index, 1);
      },
      closeDialog(){
        this.xgtkdfdqx()
      },
      bianjiClick(row) {
         this.specificationsId = row.specificationsId
         this.dialogFormVisible = true;
         this.bjtsClick()
      },
      gglxjiClick(row) {
         this.serviceTypeDto.specificationCateId = row.specificationCateId
         this.serviceTypeDto.cateDesc = row.cateDesc
         this.serviceTypeDto.cateName = row.cateName
         this.tjlxincrease = true;
      },
      bjtsClick(){
         this.$api.specificationsDetail({
                specificationsId:this.specificationsId
            }).then((res)=>{
               if (res.data.code == 200) {
                     let data = res.data.data
                     if (data.specificationValues.length==0) {
                        data.specificationValues.push({ specificationValue: null});
                     }
                     this.specificationsUpdateBatchDto = data
                  } else {
                     this.$message.error(res.data.message)
                  }
            })
      },
      ggmxscdelete(index,e) {
          this.$confirm('是否确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
               if (e.id) {
                  this.$api.deleteSpecificationValue({
                     specificationValueId:e.id
                     }).then((res) => {
                        if(res.data.code==200){
                           this.bjtsClick()
                           this.$message.success(res.data.message)
                        }else{
                           this.$message.error(res.data.message)
                        }
                  })
               }else{
                  this.specificationsUpdateBatchDto.specificationValues.splice(index, 1);
               }
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
        xiugoks() {
         for (let item of this.specificationsUpdateBatchDto.specificationValues) {
         // 直接修改每个对象的字段
            item.specificationValueId = item.id;
            delete item.id;  // 删除旧的字段
         }
         let specificationsUpdateBatchDto = {
            cateDesc:null,
            cateName:this.specificationsUpdateBatchDto.specName,
            specificationId:this.specificationsUpdateBatchDto.specificationsId,
            specificationsValueUpdateDtos:this.specificationsUpdateBatchDto.specificationValues
         }
         this.$api.updateBatchSpecifications(specificationsUpdateBatchDto).then((res)=>{
            if(res.data.code==200){
               this.getlist(this.specificationsPageDto)
               this.dialogFormVisible = false;
               this.$message.success(res.data.message)
            }else{
               this.$message.error(res.data.message)
            }
         })
        },
        dels(e) {
          this.$confirm('是否确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.deleteication({
               specificationsId:e.specificationsId
                }).then((res) => {
                  if(res.data.code==200){
                     this.getlist(this.specificationsPageDto)
                     this.$message.success(res.data.message)
                  }else{
                     this.$message.error(res.data.message)
                  }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
      fwlxdels(e) {
         //  let xhpddyz = ''
         //  this.tableData.forEach(item => {
         //    if (item.serviceName == e.serviceName) {
         //      xhpddyz = 1
         //    }
         //  });
         //  if (xhpddyz == 1) {
         //    this.$message({
         //      message: '列表里还有该类型的数据，请全部删除之后再来删除该类型',
         //      type: 'warning'
         //    });
         //    return
         //  }
          this.$confirm('是否确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.deleteSpecCate({
               specCateId:e.specificationCateId
                }).then((res) => {
                  if(res.data.code==200){
                     this.increasetypes = false
                     this.$message.success(res.data.message)
                     this.dataService()
                  }else{
                     this.$message.error(res.data.message)
                  }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
      xgtkdfdqx(){
        this.dialogFormVisible = false;
        this.serviceTypeDto={
            cateDesc:null,
            cateName:null,
            specificationCateId:null,
         }
      },
       handleCurrentChange(val) {
         this.specificationsPageDto.pageNum = val
          this.getlist(this.specificationsPageDto)
      },
      handleSizeChange(val) {
         this.specificationsPageDto.pageSize = val
          this.getlist(this.specificationsPageDto)
      },
      }
   }
</script>
<style scoped>
#specifications {
   width: 100%;
   height: 100%;
   overflow-y: auto;
   background-color: #fff;
   padding:20px 0 0 30px;
   box-sizing: border-box;
   position: relative;
}
.tos {
   display: flex;
   /* justify-content: space-between; */
   align-items: center;
   /* background: yellow; */
   margin: 20px 0 20px -15px;
 }
 .elrow{
   box-sizing: border-box;
   width: 20%;
   margin-top: -6px;
   margin: 0 40px 0 20px;
 }
 .elrowleft{
   width: 80%;
   float: left;
   box-sizing: border-box;
 }
 .elrowleft input{
   border: 2px solid #1b93ed !important;
   border-radius: 0 !important;
   width: 100%;
   -webkit-appearance: none;
   appearance: none;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #929da5;
   box-sizing: border-box;
   color: #1f3d35;
   font-size: 14px;
   height: 36px;
   line-height: 1;
   outline: none;
   padding: 3px 10px;
   transition: border-color .2s cubic-bezier(.645,.045,.355,1);
 }
 .elrowcontent{
   width: 16.66667%;
   float: left;
   box-sizing: border-box;
 }
 .search-btn {
   height: 36px;
   width: 100px;
   background: #1b93ed;
   border: 2px solid #1b93ed;
   margin: 0;
   padding: 0;
   color: #fff;
   cursor: pointer;
 }
 .zdjsdd{
   margin-bottom:20px
 }
 .zdjsdd /deep/ .el-form-item{
   margin-bottom :10px !important;
 }
 .has-border{
   border-bottom: 1px solid#DCDCDC;
 }
 .tjannos{
   display: flex;
   margin-bottom: 20px;
 }
 .left_item{
   margin-left: auto;
 }
 .right-item {
   position: absolute;
   right: 0;
   top: 5px;
   z-index: 999 !important;
 }
 .tos /deep/ .el-form-item {
     margin-bottom: 0 !important;
 }
 .form-input-wrapper {
  display: flex;
  align-items: center;
}
.input-field {
  flex: 1; /* 输入框占据剩余空间 */
  margin-right: 10px; /* 输入框和按钮之间的间距 */
}
.submit-button {
  margin-left: 10px;
}
 .btnbox {
       /* background: pink; */
       display: flex;
       width: 40%;
       align-items: center;
       justify-content: space-around;
       margin: auto;
       margin-top: 30px;
   }
   .zcyhtk /deep/ .el-form-item__label {
    width: 90px !important;
  }
  .zcyhtk /deep/ .el-form-item__content {
    margin-left: 90px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/management/specifications.vue